import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import styles from "./NotFoundPage.module.css";

export default function NotFoundPage() {
  return (
    <>
      <PageHeader
        eyebrow="Page not found"
        title="That page isn't here."
        lead="The link may be out of date. Everything on the site is reachable from the menu above."
      />
      <div className={`u-section u-shell ${styles.body}`}>
        <Link to="/" className={styles.back}>
          Back to home
        </Link>
      </div>
    </>
  );
}
